import type { ComparisonCardsAdapterProps } from "modules/storyblok/adapters/ComparisonCards";
import {
  ChakraHStack as HStack,
  ChakraList as List,
  chakraUseBreakpointValue as useBreakpointValue,
} from "@airhelp/react-ui-components";
import type { SbEditableComponentProps } from "types/storyblok";
import ComparisonCard from "./ComparisonCard";

const ComparisonCardsDesktop = ({
  content,
  sbEditable,
}: SbEditableComponentProps<Pick<ComparisonCardsAdapterProps, "content">>) => (
  <List>
    <HStack alignItems="stretch" spacing={8} my={1} {...sbEditable}>
      {content.map(({ _uid, heading, highlighted, tagText, content: cardContent }) => (
        <ComparisonCard
          key={_uid}
          heading={heading}
          highlighted={highlighted}
          tagText={tagText}
          content={cardContent}
          bgColor="greyscale.100"
        />
      ))}
    </HStack>
  </List>
);

const ComparisonCardsMobile = ({
  content,
  sbEditable,
}: SbEditableComponentProps<Pick<ComparisonCardsAdapterProps, "content">>) => (
  <List display="flex" flexDir="column" gap={3} my={1} {...sbEditable}>
    {content.map(({ _uid, heading, highlighted, tagText, content: cardContent }) => (
      <ComparisonCard
        key={_uid}
        heading={heading}
        highlighted={highlighted}
        tagText={tagText}
        content={cardContent}
        bgColor="greyscale.100"
      />
    ))}
  </List>
);

const ComparisonCards = (props: SbEditableComponentProps<Pick<ComparisonCardsAdapterProps, "content">>) =>
  useBreakpointValue({ lg: true }) ? <ComparisonCardsDesktop {...props} /> : <ComparisonCardsMobile {...props} />;

export default ComparisonCards;
